module.exports = __webpack_public_path__ + "static/media/proza.07e65246.woff2";